import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import Props from "./props";
import Select from "../../ui/Select";
import editProfessionFieldAction from "../../../../state/actions/ProfessionActions/editProfessionFieldAction";
import getProfessionCategoriesSelector from "../../../../state/selectors/ProfessionSelectors/getProfessionCategoriesSelector";
import getProfessionEditedFieldSelector from "../../../../state/selectors/ProfessionSelectors/getProfessionEditedFieldSelector";
import getSingleProfessionCategoriesSelector from "../../../../state/selectors/ProfessionSelectors/getSingleProfessionCategoriesSelector";
import isEditingProfessionSelector from "../../../../state/selectors/ProfessionSelectors/isEditingProfessionSelector";
import styled from "styled-components";

const SingleProfessionCategories: React.FC<Props> = () => {
    const isEditing = useSelector((state: Store) => isEditingProfessionSelector(state));
    const categories = useSelector((state: Store) => getProfessionCategoriesSelector(state));
    const professionCategories = useSelector((state: Store) => getSingleProfessionCategoriesSelector(state));
    const editedValues: any = useSelector((state: Store) => getProfessionEditedFieldSelector(state, "categories"));
    const dispatch = useDispatch();
    const editProfessionField = useCallback((data) => dispatch(editProfessionFieldAction(data, "categories")), [dispatch]);
    return (
        <FlexWrapper>
            <Left>Categorie</Left>
            <Right>
                {isEditing ? (
                    <Select
                        placeholder="Seleziona una categoria"
                        options={categories}
                        value={editedValues}
                        isSelectedOption={(option: ProfessionCategory) =>
                            editedValues.map((editedValue: ProfessionCategory) => editedValue.term_id).indexOf(option.term_id) > -1
                        }
                        getOptionText={(option: ProfessionCategory) => option.name}
                        setOptionKey={(option: ProfessionCategory) => option.term_id}
                        onOptionClick={(option: ProfessionCategory) => editProfessionField(option)}
                    />
                ) : (
                    professionCategories.map((professionCategory: ProfessionCategory) => professionCategory.name).join(", ")
                )}
            </Right>
        </FlexWrapper>
    );
};

export default SingleProfessionCategories;

const FlexWrapper = styled.div`
    display: flex;
    padding-bottom: 2rem;
`;

const Left = styled.div`
    width: 23%;
    font-weight: 700;
    font-size: 1.1rem;
    padding: 0 0.5rem;
    @media print {
        font-size: 1rem;
    }
`;

const Right = styled.div`
    width: calc(100% - 23%);
    font-size: 1.1rem;
    padding: 0 0.5rem;
    @media print {
        font-size: 1rem;
    }
`;
